import { Button, Col, Divider, Input, List, Modal, Pagination, Row, Skeleton, Tag } from "antd";
import { Link } from "react-router-dom";
import { useState } from "react";
import axios from "axios";
import moment from "moment";
import { useCallback } from "react";
import { requestError } from "../../controllers/functions";
import { extractTokenFromUrl } from "../../pages/Schools";
import { useEffect } from "react";
import { HomeOutlined, PlusOutlined } from "@ant-design/icons";
import QuotationModal from "./Modal.Quotation";
import PaymentModal from "./Modal.Payment";

const getSchoolId  = () =>{
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    return urlParams.get('id');
}


const SchoolInvoices = () => {   
    const [ school, setSchool ] = useState({});
    const [ openCreateQuotationModal, setOpenCreateQuotationModal ] = useState(false);
    const [ openCreatePaymentModal, setOpenCreatePaymentModal ] = useState(false);
    const [ type, setType ] = useState("quotation");


    const getSchool = useCallback((id) => {
        axios.get(`${process.env.REACT_APP_API_URI}/schools/${id}`, {
            headers: {
                Authorization: `Bearer ${extractTokenFromUrl()}`,
            },
        })
        .then((res) => {
            setSchool(res.data);
        })
        .catch((err) => {
            console.log(err);
        });
    }, []);

    useEffect(() => {
        getSchool(getSchoolId());
    }, [getSchool]);

    return (
        <div  style={{ marginTop: "1rem"}}>
            <Row gutter={[16, 16]} justify="center"  style={{ marginLeft:'0.5rem', marginRight:'0.5rem'}}>
                <Col span={24} style={{ textAlign: "center"}}>
                    <h2 style={{ marginBottom: 0 }}>{school?.name}</h2>
                    <Divider style={{ marginBottom: "0.5rem", marginTop: "1rem" }} />
                </Col>
                <Col span={24} style={{ textAlign: "center", display : "flex", justifyContent : "center", gap : "0.5rem"}}>
                    <Link to={`schools?token=${extractTokenFromUrl()}`} style={{ textDecoration: "none" }}>
                        <Button size="small" variant="dashed" color="red">
                            <HomeOutlined /> Home
                        </Button>
                    </Link>
                    <Button size="small" variant="dashed" color="primary" onClick={() => {
                        setOpenCreateQuotationModal(true);
                        setType("quotation");
                        }} >
                       <PlusOutlined /> Quotation
                    </Button>
                    <Button size="small" variant="dashed" color="purple" onClick={() => {
                        setOpenCreateQuotationModal(true);
                        setType("invoice");
                        }} >
                       <PlusOutlined /> Invoice
                    </Button>
                    <Button size="small" variant="dashed" color="green" onClick={() => setOpenCreatePaymentModal(true)}>
                        <PlusOutlined /> Payment
                    </Button>
                </Col>
                <Col span={24} style={{ textAlign: "center", marginBottom: "1rem"}}>
                    <strong>Account Balance</strong> : <span style={{ color: school?.billingAccountBalance < 0 ? "red" : "green" }}>${Math.abs(school?.billingAccountBalance)}</span>
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Payments getSchool={getSchool} openCreatePaymentModal={openCreatePaymentModal} setOpenCreatePaymentModal={setOpenCreatePaymentModal} />
                </Col>
                <Col xs={24} sm={24} md={12} lg={8} xl={8}>
                    <Invoices getSchool={getSchool} type={type} openCreateQuotationModal={openCreateQuotationModal} setOpenCreateQuotationModal={setOpenCreateQuotationModal} />
                </Col>
            </Row>
        </div>
    ); 
}

export default SchoolInvoices;

const Payments = ({ openCreatePaymentModal, setOpenCreatePaymentModal, getSchool }) => {
    const [ searchString, setSearchString ] = useState("");
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ pageSize, setPageSize ] = useState(10);
    const [ payments, setPayments ] = useState([]);
    const [ loading, setLoading ] = useState({});

    const getPayments = useCallback(() => {
        setLoading( prev => ({...prev, payments : true}) );
        const f = {
                currentPage,
                pageSize,
                searchString
            }

        const q = new URLSearchParams(f).toString();

        axios.get( process.env.REACT_APP_API_URI+`/schools/subscriptions/payments/${getSchoolId()}?${q}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
            setPayments(done.data);
            getSchool(getSchoolId());
        }).catch( error => {
            requestError({error});
        }).finally( done =>{
            setLoading( prev => ({...prev, payments : false}) );
        })
    }, [currentPage, getSchool, pageSize, searchString]);

    const voidPayment = (id) => {
        Modal.confirm({
            title: "Are you sure you want to delete this payment?",
            onCancel: () => {},
            onOk: () => {
                axios.delete( process.env.REACT_APP_API_URI+`/schools/subscriptions/payments/${id}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
                    getPayments();
                }).catch( error => {
                    requestError({error});
                })
            },
        });
    }

    useEffect(() => {
        getPayments();
    }, [getPayments]);


    return (
        <div>
        <div
            style={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            alignItems: "center", // centers vertically
            gap: 10, // space between title and input
            marginBottom: 10,
            justifyContent: "space-between",
            }}
        >
            <h3 style={{ fontSize: 15, margin: 0 }}>Payments</h3>
            <Input
            style={{ height: 29, width: 220 }}
            placeholder="Search Payments"
            onChange={(e) => {
                setSearchString(e.target.value);
                setCurrentPage(1);
            }}
            />
        </div>

        <Divider />

        <List
            dataSource={payments.payments || []}
            loading={loading?.payments}
            renderItem={(item) => (
            <List.Item
                actions={[
                <a key="list-loadmore-edit" style={{ fontSize: 11.5 }}>
                    {item.currency?.name} {parseFloat(item?.amount).toFixed(2)}
                </a>,
                ]}
                style={{ fontSize: 13 }}
            >
                <Skeleton avatar title={false} loading={item?.loading} active>
                <List.Item.Meta
                    title={
                    <Link to={`school-invoices?token=${extractTokenFromUrl()}`} style={{ textDecoration : "none"}}>
                        Receipt Number: {item?.id} - {moment(item?.date).format("ddd[,] DD MMMM YYYY")}
                    </Link>
                    }
                    description={
                    <div style={{ color: "#888" }}>
                        <div style={{ fontSize: 12, display : "flex", gap : 10 }}>
                            <div>
                            <span>{item.description || "Payment"}</span>
                            </div>
                        </div>

                        <div style={{ marginTop: "0.6rem" }}>
                        <Link to={`school-invoices?token=${extractTokenFromUrl()}`} style={{ textDecoration: "none" }}>
                        </Link>
                        <Button
                            size="small"
                            type="link"
                            onClick={() => voidPayment(item?.id)}
                            danger
                        >
                            <span style={{ fontSize: 11 }}>Delete</span>
                        </Button>
                        </div>
                    </div>
                    }
                />
                </Skeleton>
            </List.Item>
            )}
        />

        {/* Pagination */}
        {payments?.totalPayments > pageSize && (
            <div style={{ textAlign: "right", marginTop: "1rem" }}>
            <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={payments?.totalPayments}
                onChange={(page) => setCurrentPage(page)}
                size="small"
            />
            </div>
        )}


            <div style={{ paddingLeft : "1rem", paddingRight : "1rem"}}>
                <PaymentModal
                    show={openCreatePaymentModal}
                    setOpenModal={setOpenCreatePaymentModal}
                    schoolId={getSchoolId()}
                    extractTokenFromUrl={extractTokenFromUrl}
                    getPayments={getPayments}
                />
            </div>
        </div>
    );
}

const Invoices = ({ getSchool, openCreateQuotationModal, setOpenCreateQuotationModal, type }) => {
    const [ searchString, setSearchString ] = useState("");
    const [ currentPage, setCurrentPage ] = useState(1);
    const [ pageSize, setPageSize ] = useState(5);
    const [ payments, setPayments ] = useState([]);
    const [ loading, setLoading ] = useState({});

    const getInvoices = useCallback(() => {
        setLoading( prev => ({...prev, payments : true}) );
        const f = {
                currentPage,
                pageSize,
                searchString,
                schoolId : getSchoolId()
            }

        const q = new URLSearchParams(f).toString();

        axios.get( process.env.REACT_APP_API_URI+`/schools/subscriptions/invoices?${q}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
            setPayments(done.data);
            getSchool(getSchoolId());
        }).catch( error => {
            requestError({error});
        }).finally( done =>{
            setLoading( prev => ({...prev, payments : false}) );
        })
    }, [currentPage, getSchool, pageSize, searchString]);

    const deletePayment = (id, doctype ) => {
        Modal.confirm({
            title: `Are you sure you want to delete this ${doctype === "quotation" ? "quotation" : "invoice"}?`,
            onCancel: () => {},
            onOk: () => {
                setLoading( prev => ({...prev, [`deleting_${id}`] : true}) );
                axios.delete( process.env.REACT_APP_API_URI+`/schools/subscriptions/invoices/${id}`, {headers: { authorization : `Bearer ${extractTokenFromUrl()}`}} ).then( done =>{
                    getInvoices();
                }).catch( error => {
                    requestError({error});
                }).finally( () =>{
                    setLoading( prev => ({...prev, [`deleting_${id}`] : false}) );
                })
            },
        });
    }

    useEffect(() => {
        getInvoices();
    }, [getInvoices]);


    return (
        <div>
        <div
            style={{
            display: "flex",
            justifyContent: "center", // centers horizontally
            alignItems: "center", // centers vertically
            gap: 10, // space between title and input
            marginBottom: 10,
            justifyContent: "space-between",
            }}
        >
            <h3 style={{ fontSize: 15, margin: 0 }}>Invoices</h3>
            <Input
            style={{ height: 29, width: 220 }}
            placeholder="Search Invoices"
            onChange={(e) => {
                setSearchString(e.target.value);
                setCurrentPage(1);
            }}
            />
        </div>

        <Divider />

        <List
            dataSource={payments.payments || []}
            loading={loading?.payments}
            renderItem={(item) => (
            <List.Item
                actions={[
                <a key="list-loadmore-edit" style={{ fontSize: 11.5 }}>
                    {item.currency?.name} {parseFloat(item?.totalInvoiceAmount).toFixed(2)}
                </a>,
                ]}
                style={{ fontSize: 13 }}
            >
                <Skeleton avatar title={false} loading={item?.loading} active>
                <List.Item.Meta
                    title={
                    <Link to={`school-invoices?token=${extractTokenFromUrl()}`} style={{ textDecoration : "none"}}>
                        {item?.type === "quotation" ? 'Quotation' : 'Invoice'} Number: {item?.id} - {moment(item?.date).format("ddd[,] DD MMMM YYYY")}
                    </Link>
                    }
                    description={
                    <div style={{ color: "#888" }}>
                        <div style={{ fontSize: 12, display : "flex", gap : 10 }}>
                            <div>
                            <span style={{ fontWeight : 600 }}>Status:{" "}</span>
                            <span>
                                <Tag style={{ color: item?.status === "approved" ? "green" : "volcano", height: 22, fontSize:11 }}>{item?.status}</Tag>
                            </span>
                            </div>
                        </div>

                        <div style={{ marginTop: "0.6rem" }}>
                        <Link to={`school-invoices?token=${extractTokenFromUrl()}`} style={{ textDecoration: "none" }}>
                        {/* <Button
                            size="small"
                            variant="link"
                            color="green"
                            onClick={()=>{
                            // setOpenDownloadInvoiceModal(true);
                            }} 
                        >
                            <span style={{ fontSize: 11 }}> Approve </span>
                        </Button> */}
                        </Link>
                        <Button
                            size="small"
                            type="link"
                            onClick={() => deletePayment(item?.id, item?.type)}
                            loading={loading[`deleting_${item?.id}`]}
                            danger
                        >
                            <span style={{ fontSize: 11 }}>Delete</span>
                        </Button>
                        </div>
                    </div>
                    }
                />
                </Skeleton>
            </List.Item>
            )}
        />

        {/* Pagination */}
        {payments?.totalPayments > pageSize && (
            <div style={{ textAlign: "right", marginTop: "1rem" }}>
            <Pagination
                current={currentPage}
                pageSize={pageSize}
                total={payments?.totalPayments}
                onChange={(page) => setCurrentPage(page)}
                size="small"
            />
            </div>
        )}


            <div style={{ paddingLeft : "1rem", paddingRight : "1rem"}}>

                <QuotationModal
                    show={openCreateQuotationModal}
                    setOpenModal={setOpenCreateQuotationModal}
                    schoolId={getSchoolId()}
                    extractTokenFromUrl={extractTokenFromUrl}
                    getInvoices={getInvoices}
                    type={type}
                />
            </div>
        </div>
    );
}